export default "__VITE_ASSET__067414b5__"